var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive }
  ]},[_c('notifications',{attrs:{"classes":"app-notify","duration":5000,"width":600,"animation-name":"v-fade-left","position":"top right"},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('div',{staticClass:"app-notify",class:props.item.type},[_c('div',{staticClass:"app-notify-icon"},[_c('i',{staticClass:"icon material-icons"},[_vm._v("add_alert")])]),_c('div',{staticClass:"app-notify-content"},[_c('div',{staticClass:"app-notify-title"},[_vm._v(" "+_vm._s(props.item.title)+" ")]),_c('div',{staticClass:"app-notify-text",domProps:{"innerHTML":_vm._s(props.item.text)}})]),_c('div',{staticClass:"app-notify-close",on:{"click":props.close}},[_c('i',{staticClass:"icon ion-android-close"})])])]}}])}),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor,"title":_vm.$t('common.project_name'),"logo":'./img/logo.png'}},[_c('user-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullname),expression:"fullname"}],attrs:{"title":_vm.fullname,"avatar":_vm.avatar}}),_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('menu.university_management'), icon: 'school' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.university_list'),
            icon: '',
            path: '/university'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.criterion_list'),
            icon: '',
            path: '/criterion'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.criterion_category_list'),
            icon: '',
            path: '/criterion-category'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.university_template_list'),
            icon: '',
            path: '/university-template'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.university_division_list'),
            icon: '',
            path: '/university-division'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.university_type_list'),
            icon: '',
            path: '/university-type'
          }}})],1),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('menu.program_management'), icon: 'article' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.program_list'),
            icon: '',
            path: '/program'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.program_criterion_list'),
            icon: '',
            path: '/program-criterion'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.program_criterion_category_list'),
            icon: '',
            path: '/program-criterion-category'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.program_template_list'),
            icon: '',
            path: '/program-template'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.program_division_list'),
            icon: '',
            path: '/program-division'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.program_type_list'),
            icon: '',
            path: '/program-type'
          }}})],1),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('menu.board_member_management'), icon: 'feed' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.news_list'),
            icon: '',
            path: '/news'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.board_member_list'),
            icon: '',
            path: '/board-members'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.manage_content_upm'),
            icon: '',
            path: '/about/upm'
          }}})],1),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('menu.user_management'), icon: 'account_box' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.user_create'),
            icon: '',
            path: '/users/add'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('menu.user_list'),
            icon: '',
            path: '/users'
          }}})],1)],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('fixed-plugin',{attrs:{"color":_vm.sidebarBackground,"colorBg":_vm.sidebarBackgroundColor,"sidebarMini":_vm.sidebarMini,"sidebarImg":_vm.sidebarImg,"image":_vm.sidebarBackgroundImage},on:{"update:color":function($event){_vm.sidebarBackground=$event},"update:colorBg":function($event){_vm.sidebarBackgroundColor=$event},"update:color-bg":function($event){_vm.sidebarBackgroundColor=$event},"update:sidebarMini":function($event){_vm.sidebarMini=$event},"update:sidebar-mini":function($event){_vm.sidebarMini=$event},"update:sidebarImg":function($event){_vm.sidebarImg=$event},"update:sidebar-img":function($event){_vm.sidebarImg=$event},"update:image":function($event){_vm.sidebarBackgroundImage=$event}}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }